import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SmartToyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"smart_toy"}/>
}
